import { useMemo } from "react";
import { Link } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import Header from "../../components/protected/Header";
import LanguageSelector from "../../components/LanguageSelector";
import { UserAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import { useTranslations } from "../../translations";

// Cada idioma de la web abre su manual HTML correspondiente (servidos desde /public/manuals).
const FILE_BY_LANG = {
  es: "manual-es.html",
  en: "manual-en.html",
  ta: "manual-ta.html",
};

const UserGuide = () => {
  const { user } = UserAuth();
  const { language } = useLanguage();
  const { t } = useTranslations();

  const src = useMemo(() => {
    const base = process.env.PUBLIC_URL || "";
    return `${base}/manuals/${FILE_BY_LANG[language] || FILE_BY_LANG.es}`;
  }, [language]);

  const frame = (heightExpr) => (
    <div className="modern-card p-2" style={{ overflow: "hidden" }}>
      <iframe
        key={language} /* fuerza recarga al cambiar de idioma */
        title={t("userGuide")}
        src={src}
        style={{
          width: "100%",
          height: heightExpr,
          minHeight: 520,
          border: "none",
          borderRadius: 16,
          background: "#fff",
          display: "block",
        }}
      />
    </div>
  );

  // ── Con sesión: chrome completo de la app (Header + menú lateral) ──
  if (user) {
    return (
      <div className="dashboard-wrapper">
        <Header />
        <main className="dashboard-main-content">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="dashboard-title mb-1">{t("userGuide")}</h1>
              <p className="text-muted mb-0">{t("userGuideSubtitle")}</p>
            </div>
          </div>
          {frame("calc(100vh - 220px)")}
        </main>
      </div>
    );
  }

  // ── Público (desde la landing): barra mínima + manual a todo el ancho ──
  return (
    <div style={{ minHeight: "100vh", background: "#f9f9f9" }}>
      <div className="ug-public-bar">
        <Link to="/" className="ug-back">
          <BiArrowBack size={18} />
          <img src="/assets/img/landing-images/MiABC-01.png" alt="MiABC" style={{ height: 28 }} />
        </Link>
        <span className="ug-public-title">{t("userGuide")}</span>
        <LanguageSelector />
      </div>
      <div style={{ padding: 16, maxWidth: 1400, margin: "0 auto" }}>
        {frame("calc(100vh - 130px)")}
      </div>
    </div>
  );
};

export default UserGuide;
